/**
 * Return the entire auth state
 */
export const selectAgentAuth = (state) => {
    return state.auth;
};
/**
 * Return the logged in Agent profile. Return undefined if the Agent is not logged in or
 * we have not fetched the logged in Agent's profile
 */
export const selectLoggedInAgent = (state) => {
    return state.auth.loggedInAgent;
};
/**
 * Return the login info of the logged in Agent
 */
export const selectAgentLoginInfo = (state) => {
    return state.auth.agentLoginInfo;
};
/**
 * Return the Project access key which the logged in user can use to access the project
 */
export const selectSudoProjectAccessKey = (state, projectId) => {
    return state.auth.sudoAccessKeysByProjectId[projectId];
};
/**
 * Return the user access key which the logged in user can use to access the user's home
 */
export const selectSudoUserAccessKey = (state, userId) => {
    return state.auth.sudoAccessKeysByUserId[userId];
};
